/**
 * touchDetect — runtime check for touch capability.
 *
 * Bill 2026-05-10 — Phase 1 (v0.14.17 bundle).
 *
 * Used by SigningSurfaceDispatcher to decide whether to offer the
 * "finish on mobile" QR fallback when a drawn-required document loads.
 *
 * Defensive: works under SSR / Vitest by guarding `window` + `navigator`.
 */

export function isTouchDevice(): boolean {
  if (typeof window === 'undefined') return false;
  if (typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0) return true;
  return 'ontouchstart' in window;
}
